import chroma from 'chroma-js';
export const setCustomButtonColors = (customPrimaryColor, customButtonTextColor) => {
    if (!chroma.valid(customPrimaryColor))
        return;
    const buttonTextColor = customButtonTextColor && chroma.valid(customButtonTextColor)
        ? customButtonTextColor
        : chroma(customPrimaryColor).luminance() > 0.5
            ? 'black'
            : 'white';
    const buttonHoverColor = chroma(customPrimaryColor).darken(0.2).hex();
    const buttonActiveColor = chroma(customPrimaryColor).darken(0.4).hex();
    document.documentElement.style.setProperty('--button-custom-primary', customPrimaryColor);
    document.documentElement.style.setProperty('--button-custom-secondary', buttonTextColor);
    document.documentElement.style.setProperty('--button-custom-primary-hover', buttonHoverColor);
    document.documentElement.style.setProperty('--button-custom-primary-active', buttonActiveColor);
};
//# sourceMappingURL=buttonCustomColors.js.map